import { useMutation } from '@apollo/client';
import { BodyMedium, HeadingMedium, theme } from '@arnold/common';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { Loading } from '../../components';
import PublicLayout from '../../components/Common/PublicLayout';
import { PrimaryButton } from '../../components/StyledComponents';
import { confirmEmailMutation } from '../../graphql/mutations';
import auth from '../../lib/auth';
import storage from '../../lib/storage';
import RegistrationAside from './RegistrationAside';

const ConfirmEmailScreen = ({ match, history, location }: RouteComponentProps<any>) => {
  const { accessToken, lang } = match.params;
  const detectedLang = lang || storage.getDetectedLanguage()?.substring(0, 2);
  const [confirmEmail] = useMutation(confirmEmailMutation);
  const [confirmedEmail, setConfirmedEmail] = useState(undefined);
  const { t } = useTranslation('registration');

  useEffect(() => {
    auth.removeUserCookies();
  }, []);

  useEffect(() => {
    if (accessToken) {
      const confirm = async () => {
        const response = await confirmEmail({
          variables: {
            deviceToken: auth.getDeviceToken(),
          },
          context: {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        });
        setConfirmedEmail(response.data.confirmEmail);
      };
      try {
        confirm();
      } catch (e) {
        console.log(e);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PublicLayout basePath={'register/confirm'} history={history} lang={detectedLang} aside={<RegistrationAside />}>
      {confirmedEmail ? (
        <>
          <HeadingMedium margin={`0 0 ${theme.spacing.h} 0`}>{t('emailConfirmed')}</HeadingMedium>
          <BodyMedium margin={`${theme.spacing.g} 0`}>
            <Trans i18nKey="registration:emailConfirmedInfo" values={{ email: confirmedEmail }}>
              Arnold účet {{ email: confirmedEmail }} je nyní připravený k použití.
            </Trans>
          </BodyMedium>
          <PrimaryButton variant="primary" type="submit" onClick={() => history.push(`/login/${lang}`)}>
            {t('logIn')}
          </PrimaryButton>
        </>
      ) : (
        <Loading />
      )}
    </PublicLayout>
  );
};

export default ConfirmEmailScreen;
